import { clsx } from 'clsx';
import type { AssetLogoSize } from '../asset-logo';
import styles from './asset-logo-placeholder.module.scss';

interface AssetLogoPlaceholderProps {
  className?: string;
  size?: AssetLogoSize;
  symbol: string | undefined;
}

export function AssetLogoPlaceholder({ className, size = 'medium', symbol }: AssetLogoPlaceholderProps) {
  const letter = symbol?.trim().charAt(0).toUpperCase() ?? '-';
  const sizeClassName = size !== 'medium' ? styles[`size-${size}`] : undefined;

  return <span className={clsx(styles.placeholder, sizeClassName, className)}>{letter}</span>;
}
